import css from "../../css/listing/slider-no-photo.module.css";

import React from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import { useAuth } from "../common/Auth";

import doorIcon from "../../static/icons/door-lg.png";

const AuthModal = dynamic(() => import("../auth/AuthModal"), { ssr: false });

const SliderArchive = (props) => {
    const { isAuthenticated } = useAuth();

    const { onClick } = props;

    const handleLogin = () => {
        onClick();
    };

    return (
        <div className={css.container}>
            <div className={css.header}>
                <img
                    src={doorIcon.src}
                    alt="Claim to Unlock"
                    title="Claim to Unlock"
                />
                Is this your property?
            </div>
            <h5 className={css.text}>
                Unlock Photos, Data & Manage this property.
                {isAuthenticated && (
                    <button
                        type="submit"
                        className={css.button}
                        onClick={onClick}
                        title="Claim to Unlock"
                    >
                        Claim Property
                    </button>
                )}
                {!isAuthenticated && (
                    <AuthModal onSuccess={handleLogin} useFullSignup={true}>
                        <button
                            type="button"
                            className={css.button}
                            title="Claim to Unlock"
                        >
                            Claim Property
                        </button>
                    </AuthModal>
                )}
            </h5>
        </div>
    );
};

SliderArchive.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default SliderArchive;
